export default "__VITE_ASSET__CKWBhfhg__"